

































import { defineComponent, computed, Ref, ref, onMounted, ComputedRef, watch, onUnmounted } from "@vue/composition-api";
import axios from 'axios';
// Store
import { Endpoints } from '@/ts/store/Constants';

// types
import { ChannelMember } from '@/views/Admin/Channels/channelTypes';
import { mapResponseToChannelMembers } from '@/views/Admin/Channels/mappingUtil';

// components
import ChannelMemberListItem from '@/views/Admin/Channels/ChannelMembers/components/ChannelMemberListItem.vue';
import ChannelMemberProfile from '@/views/Admin/Channels/ChannelMembers/components/ChannelMemberProfile.vue';
import SubTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/SubTitle.vue';

export default defineComponent({
    components: {
        ChannelMemberListItem,
        SubTitle,
        ChannelMemberProfile,
    },
    props: {
        channelId: String,
    },
    setup(props, { root, emit }) {
        const store = root.$store;

        const channelMembers : Ref<ChannelMember[]> = ref([]);

        const activeChannelMember : Ref<ChannelMember> = ref(null);

        const showChannelMemberProfile : Ref<ChannelMember> = ref(null);

        const channelTabs: ComputedRef<any> = computed(() => {
            return store.getters['Channels/getChannelsTabs'];
        });

        const handleGoBack = () => {
            const { CHANNEL_INFO } = channelTabs.value;
            emit('changeManagementTab', CHANNEL_INFO);
        }

        const hideUserProfile = () => {
            showChannelMemberProfile.value = null;
        }

        const fetchChannelMembers = () => {
            if (props.channelId) {
                axios.get(Endpoints.Admin.Channels.CHANNEL_USERS(props.channelId)).then((response) => {
                    if (response && response.data && response.data.data) {
                        channelMembers.value = mapResponseToChannelMembers(response.data.data);
                    }
                });
            }
        };

        const handleMemberOptions = (member: ChannelMember) => {
            activeChannelMember.value = member;
        }

        const showUserProfile = (member: ChannelMember) => {
            showChannelMemberProfile.value = member;
        }

        const deactiveMemberOptions = () => {
            activeChannelMember.value = null;
        }

        const removeMember = (memberToRemove: ChannelMember) => {
            activeChannelMember.value = null;
           // remove member from the list
           channelMembers.value = channelMembers.value.filter((member) => memberToRemove.id !== member.id)
        }

        watch(() => props.channelId, (newValue, oldValue) => {
            channelMembers.value = [];
            if (!oldValue || (newValue && (newValue !== oldValue))) {
                fetchChannelMembers();
            }
        });

        onMounted(() => {
            fetchChannelMembers();
        });

        onUnmounted(() => {
            // @ts-ignore
            channelMembers.value = [];
            showChannelMemberProfile.value = null;
        });


        return {
            activeChannelMember,
            channelMembers,
            deactiveMemberOptions,
            handleGoBack,
            handleMemberOptions,
            hideUserProfile,
            removeMember,
            showChannelMemberProfile,
            showUserProfile,
        };
    }
});
